import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import {
  QualityStudioApi,
  GenerateRequest,
  GenerateResponse,
  ExecuteRequest,
  ExecuteResponse,
  SonarProject,
  SonarQualityGate,
  SonarRule,
} from './QualityStudioApi';

export class QualityStudioClient implements QualityStudioApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async getBaseUrl(): Promise<string> {
    return await this.discoveryApi.getBaseUrl('quality-studio');
  }

  async generate(request: GenerateRequest): Promise<GenerateResponse> {
    const base = await this.getBaseUrl();
    const resp = await this.fetchApi.fetch(`${base}/generate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });
    if (!resp.ok) throw new Error('Intent generation failed');
    return await resp.json();
  }

  async execute(request: ExecuteRequest): Promise<ExecuteResponse> {
    const base = await this.getBaseUrl();
    const resp = await this.fetchApi.fetch(`${base}/execute`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });
    if (!resp.ok) throw new Error('Template execution failed');
    return await resp.json();
  }

  async listProjects(): Promise<SonarProject[]> {
    const base = await this.getBaseUrl();
    const resp = await this.fetchApi.fetch(`${base}/projects`);
    if (!resp.ok) throw new Error('Failed to list SonarQube projects');
    const data = await resp.json();
    return data.components ?? [];
  }

  async listQualityGates(): Promise<SonarQualityGate[]> {
    const base = await this.getBaseUrl();
    const resp = await this.fetchApi.fetch(`${base}/qualitygates`);
    if (!resp.ok) throw new Error('Failed to list quality gates');
    const data = await resp.json();
    return data.qualitygates ?? [];
  }

  async listRules(language?: string): Promise<SonarRule[]> {
    const base = await this.getBaseUrl();
    const qs = language ? `?languages=${language}` : '';
    const resp = await this.fetchApi.fetch(`${base}/rules${qs}`);
    if (!resp.ok) throw new Error('Failed to list rules');
    const data = await resp.json();
    return data.rules ?? [];
  }
}
